export enum DropZone {
  None,
  Above,
  After,
  Below,
  Before,
  Inside
}
